import React, {useState, useEffect} from "react"
import PuzzleSelector from "./PuzzleSelector"
import ClueDelivery from "./ClueDelivery"
import puzzleData from "./puzzleData"
import importClueData from "./importClueData"

function ClueSystem(props) {    
    const [puzzleHeaders, setPuzzleHeaders] = useState([])
    const [clueContent, setClueContent] = useState([])
    const [puzzleTracker, setPuzzleTracker] = useState([])
    const [selectedPuzzle, setSelectedPuzzle] = useState("")
    const [clueGroup, setClueGroup] = useState(0)
    const [headerText, setHeaderText] = useState("")
    const [clueText, setClueText] = useState("")
    const [clueCount, setClueCount] = useState(0)
    const [totalClues, setTotalClues] = useState(0)
    const [sendClue, setSendClue] = useState(false)
        
    useEffect(() => {
        setSendClue(false)
        setPuzzleHeaders(puzzleData[props.pageId])
        setClueContent(importClueData[props.pageId])
        setPuzzleTracker([-1, -1, -1, -1, -1, -1, -1, -1])
        setHeaderText("NYPD Helpdesk")
        setClueText("You haven't asked for any clues yet.")
    }, [props.pageId])
    
    useEffect(() => {
        setSelectedPuzzle(puzzleHeaders[0])
    }, [puzzleHeaders])
    
    useEffect(() => {
        let updateClueGroup = puzzleHeaders.indexOf(selectedPuzzle)
        if (updateClueGroup === -1) {updateClueGroup = 0}
        setClueGroup(updateClueGroup)
    }, [puzzleHeaders, selectedPuzzle, props.pageId])
    
    function visibleCluesUpdate(addName, removeName) {
        const localArray = clueContent
        localArray.forEach(puzzle => {
            if (puzzle.name === removeName) {
                puzzle.visible = false
                if (puzzle.name === "The Blueprint Puzzle") {
                    localArray.forEach(otherPuzzle => {
                        if (otherPuzzle.name === "People's Locations" || otherPuzzle.name === "The Route Code") {
                            otherPuzzle.visible = false
                        }
                    })
                } 
            }
            if (puzzle.name === addName) {
                puzzle.visible = true
                if (puzzle.name === "The Temperature") {
                    localArray.forEach(otherPuzzle => {
                        if (otherPuzzle.name === "The Time" || otherPuzzle.name === "The Colour Bars") {
                            otherPuzzle.visible = true
                        }
                    })
                }
                setSelectedPuzzle(puzzleHeaders[puzzle.id])
            }
        })
        setClueContent(localArray)
    }
        
    useEffect(() => {
        if (props.updateClues) {
            visibleCluesUpdate(props.addClueOption, props.removeClueOption)
            props.callBackCluesUpdated()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[props.updateClues])
                           
    function handleChange(event) {
        const {value} = event.target
        setSelectedPuzzle(value)
    }
    
    
    function handleNewClue() {
        const clues = (clueContent[clueGroup].clues);
        const newPuzzleTracker = puzzleTracker.map((value, index) => {
            if (index === clueGroup && value < 3) {
                const nextClue = value + 1
                return (nextClue)
            } else {
                return value
            }
        })
        setPuzzleTracker(newPuzzleTracker)
        const clueNumber = newPuzzleTracker[clueGroup]
        const clueToUse = clues[clueNumber]
        const totalClueNumber = clueContent[clueGroup].total
        setClueText(clueToUse)
        if (clueNumber + 1 < totalClueNumber) {
            setClueCount(clueNumber + 1)
            console.log("setting clue count to: " + clueNumber)
        } else {
            setClueCount(totalClueNumber)
            console.log("setting clue count to: " + totalClueNumber)
            
        }
        setTotalClues(totalClueNumber)
        setHeaderText(selectedPuzzle)
        handleSend()
        props.callBackTimer(newPuzzleTracker[clueGroup])
    }
    
    function handleSend() {
        setSendClue(true)
        document.getElementById("printer").play()
    }
    
    function clearClue() {
        setSendClue(false)
    }
    
    return (
        <div className = "clueSystemWrapper">
            <h1 className="clueTitle">NYPD HELPDESK</h1>
            <h3 className="clueTagLine"><em>Help Is Always At Hand</em></h3>

            <PuzzleSelector puzzleData={clueContent} newClue={handleNewClue} prevClue={handleSend} handleChange={handleChange} selectedPuzzle={selectedPuzzle}/>
            <ClueDelivery clueHeader={headerText} clue={clueText} clueCount={clueCount} totalClues={totalClues} handleClick={clearClue} sendClue={sendClue} />
        </div>
    )
}

export default ClueSystem